import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../utils/axiosInstance";

export const spotApi = createAsyncThunk(
  "spot_fintso",
  async ({ name = "", startDate = "", endDate = "" }) => {
    const params = {};

    // Add name to the query if provided
    if (name) {
      params.customerName = name;
    }

    // Add date range to the query if provided
    if (startDate) {
      params.startDate = startDate;
    }
    if (endDate) {
      params.endDate = endDate;
    }

    const response = await axiosInstance.get("/fintso_transactions/spot", {
      params, // Pass the parameters to the API request
    });
    if (response) {
      // console.log("customerName", response.data);
      return response.data;
    }
  }
);

const spotSlice = createSlice({
  name: "spot_fintso",
  initialState: {
    spot: [],
    errors: [],
    loading: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(spotApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(spotApi.fulfilled, (state, action) => {
        state.spot = action.payload;
        state.loading = false;
      })
      .addCase(spotApi.rejected, (state, action) => {
        state.errors.push(action.error.message);
        state.loading = false;
      });
  },
});

export default spotSlice.reducer;
